var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"customer-wrapper"},[_c('div',{staticClass:"container"},[_c('p',[_vm._v("개인의 자율성과 경험을 극대화 시키는 "),_c('br'),_vm._v("학습 설계 & 맞춤 교육")]),_c('p',[_c('span',[_vm._v("23년")]),_vm._v(" 동안 글로벌 역량의"),_c('br'),_c('span',[_vm._v("場")]),_vm._v("을 만들어,"),_c('br'),_vm._v("현재 "),_c('span',[_vm._v("500여")]),_vm._v(" 고객사와 함께 하고 있습니다. ")])])])
}]

export { render, staticRenderFns }